/**
 * Equalize height of stat counter descriptions to ensure horizontal alignment of counters.
 * Desktop only: hover delay to prevent flicker when moving cursor between cards.
 * Not run in the block editor (backend) so editor keeps vertical stacked layout and no hover.
 */

const DESKTOP_BREAKPOINT = 1200;
const HOVER_LEAVE_DELAY = 50;

const adjustHeights = () => {
  const descriptions = document.querySelectorAll( '.e-stn--stat-counter-cards .e-ctr__d' );
  if ( ! descriptions.length ) return;

  descriptions.forEach( ( el ) => ( el.style.height = 'auto' ) );
  const maxHeight = Math.max( ...Array.from( descriptions, ( el ) => el.offsetHeight ) );
  descriptions.forEach( ( el ) => ( el.style.height = `${ maxHeight }px` ) );
};

const attachCardListeners = ( cards, wrapper ) => {
  let leaveTimeout = null;

  const clearLeaveTimeout = () => {
    if ( leaveTimeout ) {
      clearTimeout( leaveTimeout );
      leaveTimeout = null;
    }
  };

  const removeAllHovered = () => {
    cards.forEach( ( c ) => c.classList.remove( 'is-hovered' ) );
    wrapper.classList.remove( 'has-hovered-card' );
  };

  cards.forEach( ( card ) => {
    card.addEventListener( 'mouseenter', () => {
      if ( window.innerWidth < DESKTOP_BREAKPOINT ) return;
      clearLeaveTimeout();
      removeAllHovered();
      card.classList.add( 'is-hovered' );
      wrapper.classList.add( 'has-hovered-card' );
    } );

    card.addEventListener( 'mouseleave', () => {
      if ( window.innerWidth < DESKTOP_BREAKPOINT ) return;
      clearLeaveTimeout();
      leaveTimeout = setTimeout( () => {
        card.classList.remove( 'is-hovered' );
        wrapper.classList.remove( 'has-hovered-card' );
        leaveTimeout = null;
      }, HOVER_LEAVE_DELAY );
    } );

    card.addEventListener( 'click', ( e ) => {
      if ( window.innerWidth >= DESKTOP_BREAKPOINT ) return;
      e.preventDefault();
      cards.forEach( ( c ) => c !== card && c.classList.remove( 'is-expanded' ) );
      card.classList.toggle( 'is-expanded' );
    } );
  } );

  wrapper.addEventListener( 'mouseleave', () => {
    if ( window.innerWidth < DESKTOP_BREAKPOINT ) return;
    clearLeaveTimeout();
    removeAllHovered();
  } );
};

const initHoverDelay = () => {
  const wrapper = document.querySelector( '.e-stn--stat-counter-cards .e-col--counter-wrapper' );
  if ( ! wrapper ) return;
  attachCardListeners( wrapper.querySelectorAll( ':scope > .e-div' ), wrapper );
  wrapper.classList.add( 'is-initialized' );
};

const runStatCounter = () => {
  adjustHeights();
  initHoverDelay();
};

const initStatCounter = () => {
  if ( document.querySelector( '.editor-styles-wrapper' ) ) return;

  window.addEventListener( 'load', runStatCounter );
  window.addEventListener( 'resize', adjustHeights );

  if ( document.readyState === 'complete' || document.readyState === 'interactive' ) {
    runStatCounter();
  }
};

initStatCounter();
